module.exports = __webpack_public_path__ + "img/goto_black.92cceb09.svg";